import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from '../../styled/containers';
import CardList from '../card-list';
import { Header, Wrapper } from './styles';

const allPeopleQuery = graphql`
  query personCollectionQuery {
    allContentfulDataPerson {
      edges {
        node {
          ...PersonFragment
        }
      }
    }
  }
`;

const PersonCollection = ({ people, category, headerText }) => {
  const allPeople = useStaticQuery(allPeopleQuery);
  let peopleList;

  if (!people || !people.length) {
    if (!category) return null;

    peopleList = [...allPeople.allContentfulDataPerson.edges]
      .map((edge) => edge.node)
      .filter((person) => person.category === category);
  } else {
    peopleList = people;
  }

  return (
    <Wrapper>
      <Container>
        <Header>{headerText}</Header>
        <CardList list={peopleList} columns={3} />
      </Container>
    </Wrapper>
  );
};

PersonCollection.propTypes = {
  people: PropTypes.array,
  category: PropTypes.string,
  headerText: PropTypes.string,
};

export default PersonCollection;

export const PersonCollectionAssembly = ({ contentfulData }) => (
  <PersonCollection
    people={contentfulData.people}
    category={contentfulData.category}
    headerText={contentfulData.headerText}
  />
);

PersonCollectionAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
